const promiseMiddleware = store => next => action => {
  next(action);
};

const localStorageMiddleware = store => next => action => {
  next(action);
};

export { promiseMiddleware, localStorageMiddleware };



// WEBPACK FOOTER //
// ./src/middleware/api.js